@let currentTab = insightPopupService.currentTab$ | async;
@let selectedLearningPackageId = insightPopupService.selectedLearningPackageId$ | async;
@let studyProgresses = insightPopupService.studyProgresses$ | async;
@let isAdminViewingOtherLearner = impersonationService.isImpersonationMode$ | async;

<app-popup-container
    *ngIf="selectedLearningPackageId !== null && selectedLearningPackageId !== undefined && studyProgresses !== null && studyProgresses !== undefined">

    <app-popup-wizard-header>
        <div class="mm-insight-popup-header">
            <div class="mm-insight-popup-header-data">
                <div class="mm-insight-popup-header-data-title">{{ studyProgresses.learningPackageName }}</div>
            </div>
            <div class="mm-insight-popup-tabs" *ngIf="currentTab !== undefined && currentTab !== null">
                <div class="mm-insight-popup-tabs-list">
                    <div class="mm-insight-popup-tab">
                        <div [class.mm-insight-popup-tab-button-active]="currentTab ===  InsightTabs.DETAILS"
                             class="mm-insight-popup-tab-button"
                             (click)="insightPopupService.changeTab(InsightTabs.DETAILS)"
                             [title]="'learningGoal.insightsPopup.details.tabTitle' | translate">
                            <mm-text-overflow-ellipsis
                                class="mm-insight-popup-tab-button-text"
                                [text]="'learningGoal.insightsPopup.details.tabTitle' | translate">
                            </mm-text-overflow-ellipsis>
                            <app-icon icon="circle-info-light"
                                      class="mm-insight-popup-tab-button-icon"></app-icon>
                        </div>

                        @if (data.studyProgress.type === 'managedTutor') {
                            <div [class.mm-insight-popup-tab-button-active]="currentTab === InsightTabs.TOPICS"
                                 class="mm-insight-popup-tab-button"
                                 (click)="insightPopupService.changeTab(InsightTabs.TOPICS)"
                                 [title]="'learningGoal.insightsPopup.topics.tabTitle' | translate">
                                <mm-text-overflow-ellipsis
                                    class="mm-insight-popup-tab-button-text"
                                    [text]="'learningGoal.insightsPopup.topics.tabTitle' | translate">
                                </mm-text-overflow-ellipsis>
                                <app-icon icon="goal-net-light"
                                          class="mm-insight-popup-tab-button-icon"></app-icon>
                            </div>
                        }

                        @if (data.studyProgress.type === 'learningPackage') {
                            <div [class.mm-insight-popup-tab-button-active]="currentTab ===  InsightTabs.QUESTIONS"
                                 class="mm-insight-popup-tab-button"
                                 (click)="insightPopupService.changeTab(InsightTabs.QUESTIONS)"
                                 [title]="'learningGoal.insightsPopup.questions.tabTitle' | translate">
                                <mm-text-overflow-ellipsis
                                    class="mm-insight-popup-tab-button-text"
                                    [text]="'learningGoal.insightsPopup.questions.tabTitle' | translate">
                                </mm-text-overflow-ellipsis>
                                <app-icon icon="goal-net-light"
                                          class="mm-insight-popup-tab-button-icon"></app-icon>
                            </div>
                            <div
                                [class.mm-insight-popup-tab-button-active]="currentTab ===  InsightTabs.LEARNING_HISTORY"
                                class="mm-insight-popup-tab-button"
                                (click)="insightPopupService.changeTab(InsightTabs.LEARNING_HISTORY)"
                                [title]="'learningGoal.insightsPopup.learningProgressHistory.tabTitle' | translate">
                                <mm-text-overflow-ellipsis
                                    class="mm-insight-popup-tab-button-text"
                                    [text]="'learningGoal.insightsPopup.learningProgressHistory.tabTitle' | translate">
                                </mm-text-overflow-ellipsis>
                                <app-icon icon="chart-line"
                                          class="mm-insight-popup-tab-button-icon"></app-icon>
                            </div>
                            @if (isAdminViewingOtherLearner !== null && isAdminViewingOtherLearner === false) {
                                <div [class.mm-insight-popup-tab-button-active]="currentTab ===  InsightTabs.FEEDBACK"
                                     class="mm-insight-popup-tab-button"
                                     (click)="insightPopupService.changeTab(InsightTabs.FEEDBACK)"
                                     [title]="'learningGoal.insightsPopup.feedback.tabTitle' | translate">
                                    <mm-text-overflow-ellipsis
                                        class="mm-insight-popup-tab-button-text"
                                        [text]="'learningGoal.insightsPopup.feedback.tabTitle' | translate ">
                                    </mm-text-overflow-ellipsis>
                                    <app-icon icon="message-pen-light"
                                              class="mm-insight-popup-tab-button-icon"></app-icon>
                                </div>
                            }
                        }

                        <div [class.mm-insight-popup-tab-button-active]="currentTab ===  InsightTabs.SKILLS_PROFILE"
                             class="mm-insight-popup-tab-button"
                             (click)="insightPopupService.changeTab(InsightTabs.SKILLS_PROFILE)"
                             [title]="'learningGoal.insightsPopup.skillsProfile.tabTitle' | translate">
                            <mm-text-overflow-ellipsis
                                class="mm-insight-popup-tab-button-text"
                                [text]="'learningGoal.insightsPopup.skillsProfile.tabTitle' | translate">
                            </mm-text-overflow-ellipsis>
                            <app-icon icon="chart-radar"
                                      class="mm-insight-popup-tab-button-icon"></app-icon>
                        </div>


                    </div>
                </div>
                @if (data.studyProgress.type === 'learningPackage') {
                    <mm-learning-progress-insight-popup class="mm-insight-popup-tabs-learning-progress"
                                                        [studyProgress]="studyProgresses"></mm-learning-progress-insight-popup>
                }
            </div>
        </div>
    </app-popup-wizard-header>

    <app-popup-content class="mm-insight-popup-content">
        <mm-detail-insight-popup class="mm-insight-popup-content-component"
                                 *ngIf="currentTab === InsightTabs.DETAILS"></mm-detail-insight-popup>
        @if (currentTab === InsightTabs.TOPICS) {
            <mm-topics-insight-popup class="mm-insight-popup-content-component"></mm-topics-insight-popup>
        }
        <mm-questions-insight-popup class="mm-insight-popup-content-component"
                                    *ngIf="currentTab === InsightTabs.QUESTIONS"></mm-questions-insight-popup>
        <mm-feedback-insight-popup class="mm-insight-popup-content-component"
                                   *ngIf="currentTab === InsightTabs.FEEDBACK"></mm-feedback-insight-popup>
        <mm-learning-progress-history-insight-popup
            class="mm-insight-popup-content-component mm-insight-popup-content-diagrams"
            *ngIf="currentTab === InsightTabs.LEARNING_HISTORY"></mm-learning-progress-history-insight-popup>
        <mm-skill-profile-popup class="mm-insight-popup-content-component mm-insight-popup-content-diagrams"
                                *ngIf="currentTab === InsightTabs.SKILLS_PROFILE"></mm-skill-profile-popup>
    </app-popup-content>
</app-popup-container>
